// extracted by mini-css-extract-plugin
module.exports = {"quantityTypeContainer":"VIP_QuantityType__quantityTypeContainer","quantityTypeLabel":"VIP_QuantityType__quantityTypeLabel"};